<template>
  <vx-card>
    <div class="flex justify-end">
      <vs-button @click="$router.push({name:'org_management_area'})" color="danger" type="filled" icon-pack="feather" icon="icon-x" class="mr-4">Cancel</vs-button>
      <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-save" @click.prevent="saveArea()">Save</vs-button>
    </div>

    <div class="pt-8 w-full md:w-1/2">
        <div class="vx-row mb-6">
        <div class="vx-col w-full">
            <span>Area Name</span>
        </div>
        <div class="vx-col w-full">
            <vs-input class="w-full" v-model="area" />
        </div>
        </div>
        <div class="vx-row mb-6">
        <div class="vx-col w-full">
            <span>Site</span>
        </div>
        <div class="vx-col w-full">
            <vs-select v-model="site" class="w-full select-large">
                <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in siteOptions" class="w-full" />
            </vs-select>
        </div>
        </div>
    </div>
    
    <div class="flex">
        <div class="flex-grow">
            <div>Free Camera</div>
            <div class="box-camrea-select w-full" style="height:400px;overflow-y: auto;">
                <vs-input class="w-full pb-2" v-model="searchFree" placeholder="Search ..."></vs-input>
                <select v-model="selectedCamera" multiple>
                    <option v-for="(fCam,idx) in freeCamera" :key="idx" :value="fCam.camId">{{fCam.name}}</option>
                </select>
            </div>
        </div>
        <div class="flex flex-col justify-evenly items-center pt-10" style="width:100px;height:400px;overflow-y: auto;">
            <a href="#" @click.prevent="selectAll()"><feather-icon icon="ChevronsRightIcon" svgClasses="icon" /></a>
            <a href="#" @click.prevent="unselectAll()"><feather-icon icon="ChevronsLeftIcon" svgClasses="icon" /></a>
        </div>
        <div class="flex-grow">
            <div>Added Camera</div>
            <div class="box-camrea-select w-full" style="height:400px;overflow-y: auto;">
                <vs-input class="w-full pb-2" v-model="searchAdded" placeholder="Search ..."></vs-input>
                <select v-model="selectedAddedCamera" multiple>
                    <option v-for="(aCam,idx) in addedCamera" :key="idx" :value="aCam.camId">{{aCam.name}}</option>
                </select>
            </div>
        </div>
    </div>
  </vx-card>
</template>

<script>
    import api from "@/api";
    export default {
        data() {
            return {
                isEdit: false,
                area: '',
                site: '',
                searchFree: '',
                searchAdded: '',
                siteOptions: [],
                freeCamera: [],
                addedCamera: [],
                selectedCamera: [],
                selectedAddedCamera: [],
                originalFreeCamera: [],
                originalAddedCamera: [],
            }
        },
        watch: {
            site(x,y) {
                if(x != y) {
                    this.getFreeCamera(x)
                    this.addedCamera = this.originalAddedCamera = [];
                    this.selectedCamera = [];
                    this.selectedAddedCamera = [];
                }
            },
            searchFree(x,y) {
                if(x != '' && x.length > 2) {
                    if(x != y) {
                        console.log(x)
                        this.freeCamera = this.originalFreeCamera.filter(e => e.name.toLowerCase().includes(x.toLowerCase()))
                    }
                } else {
                    this.freeCamera = this.originalFreeCamera
                }
            },
            searchAdded(x,y) {
                if(x != '' && x.length > 2) {
                    if(x != y) {
                        console.log(x)
                        this.addedCamera = this.originalAddedCamera.filter(e => e.name.toLowerCase().includes(x.toLowerCase()))
                    }
                } else {
                    this.addedCamera = this.originalAddedCamera
                }
            }
        },  
        computed: {
            currentArea() {
                return this.$store.state.currentArea
            },
        },
        mounted() {
            this.searchFree = ''
            this.searchAdded = ''
            this.selectedCamera = []
            this.selectedAddedCamera = []

            this.getSiteLists()

            if(this.$route.params.id) {
                this.isEdit = true
                this.$store.dispatch('updateCurrentArea', this.$route.params.id)

                this.area = this.currentArea.name
                this.site = this.currentArea.siteId

                this.getAddedCamera(this.$route.params.id)

                if(this.currentArea.siteId != '') {
                    this.getFreeCamera(this.currentArea.siteId)
                }
            }
        },
        methods: {
            isInSelected(cam) {
                var index = this.selectedCamera.indexOf(cam);
                if (index !== -1) {
                    return true
                }

                return false
            },
            addOrRemove(array, value) {
                var index = array.indexOf(value);
                if (index === -1) {
                    array.push(value);
                } else {
                    array.splice(index, 1);
                }
            },
            selectAll() {
                if(this.selectedCamera.length > 0) {
                    const selectedFreeCamera = this.freeCamera.filter((cam) => this.selectedCamera.includes(cam.camId));
                    this.addedCamera = this.addedCamera.concat(selectedFreeCamera)
                    selectedFreeCamera.forEach(e => {
                        var index = this.freeCamera.indexOf(e);
                        this.freeCamera.splice(index, 1);
                    })

                    const originalSelectedFreeCamera = this.originalFreeCamera.filter((cam) => this.selectedCamera.includes(cam.camId));
                    this.originalAddedCamera = this.originalAddedCamera.concat(originalSelectedFreeCamera)
                    originalSelectedFreeCamera.forEach(e => {
                        var index = this.originalFreeCamera.indexOf(e);
                        this.originalFreeCamera.splice(index, 1);
                    })

                    this.selectedCamera = []
                } else {
                    this.addedCamera = this.addedCamera.concat(this.freeCamera)
                    this.originalAddedCamera = this.originalAddedCamera.concat(this.freeCamera)
                    this.freeCamera.forEach(e => {
                        var index = this.originalFreeCamera.indexOf(e);
                        this.originalFreeCamera.splice(index, 1);
                    })

                    this.freeCamera = []
                }
            },
            unselectAll() {
                if(this.selectedAddedCamera.length > 0) {
                    const filteredAddedCamera = this.addedCamera.filter((cam) => this.selectedAddedCamera.includes(cam.camId));
                    this.freeCamera = this.originalFreeCamera = this.freeCamera.concat(filteredAddedCamera)
                    filteredAddedCamera.forEach(e => {
                        var index = this.addedCamera.indexOf(e);
                        this.addedCamera.splice(index, 1);
                    })

                    const originalSelectedAddedCamera = this.originalAddedCamera.filter((cam) => this.selectedAddedCamera.includes(cam.camId));
                    this.originalFreeCamera = this.freeCamera = this.originalFreeCamera.concat(originalSelectedAddedCamera)
                    originalSelectedAddedCamera.forEach(e => {
                        var index = this.originalAddedCamera.indexOf(e);
                        this.originalAddedCamera.splice(index, 1);
                    })

                    this.selectedAddedCamera = []
                } else {
                    this.freeCamera = this.freeCamera.concat(this.addedCamera)
                    this.originalFreeCamera = this.originalFreeCamera.concat(this.addedCamera)
                    this.addedCamera.forEach(e => {
                        var index = this.originalAddedCamera.indexOf(e);
                        this.originalAddedCamera.splice(index, 1);
                    })

                    this.addedCamera = []
                }
            },
            getSiteLists() {
                this.$vs.loading()
                api.sites()
                .then(result => result.data)
                .then(data => {
                    if(data.status) {
                        let opts = [{
                            value: '',
                            text: '-- Select Site --'
                        }]
                        data.data.map(d => {
                            opts.push({
                                value: d.id,
                                text: d.name
                            })
                        })
                        this.siteOptions = opts
                    }
                    this.$vs.loading.close()
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
            },
            getFreeCamera(site) {
                this.$vs.loading()
                api.freeCam({
                    siteId: site
                })
                .then(result => result.data)
                .then(data => {
                    if(data.status) {
                        this.freeCamera = data.data
                        this.originalFreeCamera = data.data
                    }
                    this.$vs.loading.close()
                })
                .catch((e) => {
                    console.log(e)
                    this.$vs.loading.close()
                });
            },
            getAddedCamera(id) {
                api.addedCam({
                    areaId: id
                })
                .then(result => result.data)
                .then(data => {
                    if(data.status) {
                        this.addedCamera = data.data
                        this.originalAddedCamera = data.data
                    }
                })
                .catch((e) => {
                    console.log(e)
                });
            },
            saveArea() {
                let params = {
                    name: this.area,
                    siteId: this.site,
                    camera: this.addedCamera,
                    statusId: 1
                }
                if(this.$route.params.id) {
                    params['id'] = this.$route.params.id
                }
                this.$vs.loading()
                api.saveArea(params, this.isEdit)
                .then((result) => result.data)
                .then((data) => {
                    console.log(data)
                    console.log("status => " + data.status)
                    this.$vs.loading.close()
                  
                    if(!data.status) {
                        this.$vs.notify({
                            title:'Error',
                            text: data.message,
                            color:'danger',
                            position:'bottom-center'
                        })
                    } else {
                        this.$vs.notify({
                            title:'Success',
                            text:'Success save data',
                            color:'success',
                            position:'bottom-center'
                        })
                        setTimeout(() => {
                            this.$router.push({name:'org_management_area'})
                        },500)
                    }
                })
                .catch((e) => {
                    console.log(e)

                    this.$vs.notify({
                        title:'Failed',
                        text:'Save data failed',
                        color:'danger',
                        position:'bottom-center'
                    })
                    
                    this.$vs.loading.close()
                });
            }
        },
    }
</script>